export const SKILL_CATEGORIES = [
  "Analysis",
  "Research",
  "Ideation",
  "Creation",
  "Planning",
  "Evaluation",
  "Communication",
  "Decision-Making",
] as const;

export type SkillCategory = (typeof SKILL_CATEGORIES)[number];
